import { useEffect, useState, useRef } from "react";

const CountUp = ({ end, suffix = "", duration = 2000, fontClass = "", style = {} }) => {
  const [count, setCount] = useState(0);
  const ref = useRef();
  const observer = useRef();
  const intervalRef = useRef();

  useEffect(() => {
    const start = 0;
    const incrementTime = 50;
    const totalSteps = duration / incrementTime;
    const step = (end - start) / totalSteps;

    const handleIntersect = (entries) => {
      if (entries[0].isIntersecting) {
        clearInterval(intervalRef.current); // Clear any running interval
        let current = start;
        intervalRef.current = setInterval(() => {
          current += step;
          if (current >= end) {
            setCount(end);
            clearInterval(intervalRef.current);
          } else {
            setCount(Math.ceil(current));
          }
        }, incrementTime);
      } else {
        clearInterval(intervalRef.current);
        setCount(0); // Reset when leaving view
      }
    };

    observer.current = new IntersectionObserver(handleIntersect, {
      threshold: 0.6,
    });

    if (ref.current) {
      observer.current.observe(ref.current);
    }

    return () => {
      clearInterval(intervalRef.current);
      observer.current?.disconnect();
    };
  }, [end, duration]);

  return (
    <h2 ref={ref} className={fontClass} style={style}>
      {count}
      <span>{suffix}</span>
    </h2>
  );
};

export default CountUp;
